// Reusable inline delete-confirmation modal. iOS-friendly styling.
import { AlertTriangle, X } from "lucide-react";
import { useI18n } from "@/context/I18nContext";

export function ConfirmDelete({ open, title, message, onConfirm, onCancel }) {
  const { lang } = useI18n();
  if (!open) return null;
  return (
    <div data-testid="confirm-delete-modal" onClick={onCancel}
      className="fixed inset-0 z-[90] bg-black/50 backdrop-blur-sm grid place-items-center p-4">
      <div onClick={(e) => e.stopPropagation()} className="w-full max-w-sm neu p-5 space-y-4">
        <div className="flex items-start gap-3">
          <div className="w-11 h-11 rounded-2xl bg-red-100 text-red-600 grid place-items-center shrink-0">
            <AlertTriangle className="w-5 h-5" />
          </div>
          <div className="flex-1 min-w-0">
            <h3 className="font-display font-extrabold text-base">{title || (lang === "ar" ? "تأكيد الحذف" : "Confirm delete")}</h3>
            {message && <p className="text-sm text-slate-500 mt-1">{message}</p>}
          </div>
          <button onClick={onCancel} className="w-8 h-8 rounded-full neu-sm grid place-items-center">
            <X className="w-4 h-4" />
          </button>
        </div>
        <div className="grid grid-cols-2 gap-3">
          <button data-testid="confirm-delete-cancel" onClick={onCancel}
            className="h-11 rounded-xl neu-sm font-bold text-slate-700 active:scale-95">
            {lang === "ar" ? "إلغاء" : "Cancel"}
          </button>
          <button data-testid="confirm-delete-yes" onClick={onConfirm}
            className="h-11 rounded-xl bg-red-600 text-white font-bold shadow-md active:scale-95">
            {lang === "ar" ? "حذف" : "Delete"}
          </button>
        </div>
      </div>
    </div>
  );
}
